import i18n from "i18next";
import HttpApi from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

i18n
  .use(HttpApi)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    backend: {
      /* translation file path */
      loadPath: "/assets/i18n/translations/{{lng}}.json",
    },
    lng: "en",
    interpolation: {
      escapeValue: false,
    },
    debug: false,
    detection: {
      order: ["localStorage", "navigator"], // First look in localStorage, then navigator
      caches: ["localStorage"], // Save the language in local storage
    },
  });

export default i18n;
